import '@arco-design/theme-line/index.less';
import { useLogin } from './hooks/useLogin';
import Login from './pages/Login';
import Home from './pages/Home';
import Preview from './pages/Preview';
import './App.css';
import { Publish } from './pages/Publish';

function App() {
  const [{ username, accesses }, setLoginStatus] = useLogin();

  if (window.location.pathname.includes('publish')) {
    return <Publish />;
  }

  if (!username) {
    return <Login loginSuccessRedirect={(status) => setLoginStatus(status)} />;
  } else if (window.location.pathname.includes('preview')) {
    return <Preview />;
  }

  return (
    <Home
      username={username}
      accesses={accesses}
      logOut={() => {
        localStorage.removeItem('username');
        localStorage.removeItem('accesses');
        setLoginStatus({
          username: null,
          accesses: [],
        });
      }}
    />
  );
}

export default App;
